export default __webpack_public_path__ + "static/media/eventMap.ef856fcf.png";